import { FirebaseMessaging } from '@capacitor-firebase/messaging'
import EnvUtils from '~/src/utils/EnvUtils'

interface ReturnsType {
  initNotificationPermission(): Promise<void | undefined>,
}

const useInitNotificationPermission = (): ReturnsType => {
  /**
   * check if the permission is already allowed
   * and if not request the permission to send notifications
   */
  const initNotificationPermission = async (): Promise<void | undefined> => {
    if (EnvUtils.isDeviceWeb) {
      return
    }

    await FirebaseMessaging.requestPermissions()
  }

  return { initNotificationPermission }
}

export default useInitNotificationPermission
